/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

export const languages = {
    de: "de",
    en: "en"
}

export const countries = {
    de: "DE",
    gb: "GB",
    ch: "CH"
}

export const cultures = {
    deDE: "de-DE",
    enGB: "en-GB",
    deCH: "de-CH",
}
